import graphql__d1873d779fe693da2e21 from "./__generated__/ConfirmSupplierServicePeriodProposalsDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useRelayEnvironment} from "react-relay/hooks";
import {useIntl} from "react-intl";
import FormDialog from "./FormDialog";
import Section from "../form/Section";
import Row from "../form/Row";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import type {ConfirmSupplierServicePeriodProposalsDialogMutation} from "./__generated__/ConfirmSupplierServicePeriodProposalsDialogMutation.graphql";

type Props = {
    supplier: {
        supplierIdentifier: string
        name: string
        proposedServicePeriodCount: number
    }
    onClose: (confirmed: boolean) => void
}

/**
 * Asks before confirming all proposed service periods of a supplier at once. The caller reloads
 * whatever lists the proposals once they are confirmed.
 */
const ConfirmSupplierServicePeriodProposalsDialog: React.FC<Props> = ({supplier, onClose}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = () => {
        commitMutationWithErrorHandling<ConfirmSupplierServicePeriodProposalsDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__d1873d779fe693da2e21,
                variables: {input: {id: supplier.supplierIdentifier}},
                onCompleted: () => onClose(true),
                onError: () => onClose(false),
            },
            addError,
            {customErrorMessage: intl.formatMessage({id: 'errors.failedToConfirmSupplierServicePeriodProposals'})}
        );
    };

    return (
        <FormDialog handleCloseDialog={() => onClose(false)}
                    handleSubmission={handleSubmission}
                    initialValues={{}}
                    headline={intl.formatMessage({id: 'dialog.ConfirmSupplierServicePeriodProposalsDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.ConfirmSupplierServicePeriodProposalsDialog.submitLabel'})}>
            <Section>
                <Row>
                    <p className="text-gray-900">
                        {intl.formatMessage(
                            {id: 'dialog.ConfirmSupplierServicePeriodProposalsDialog.confirmMessage'},
                            {count: supplier.proposedServicePeriodCount, name: supplier.name}
                        )}
                    </p>
                </Row>
            </Section>
        </FormDialog>
    );
};

export default ConfirmSupplierServicePeriodProposalsDialog;
